export const ROUTE_PATHS = {
  HOME: '/',
  INDIVIDUAL_PATH: '/get-started',
  UNDER_CONSTRUCTION: '/under-development',
  ABOUT_RELYHT: '/about-reliht',
  TERMS_CONDITIONS: '/terms-and-conditions',
  PRIVACY_POLICY: '/privacy-policy',
  CONNECT: '/connect',
  USER_HELP: '/forgot-info',
  ADMIN_HOME: '/admin',
  ADMIN_GROUPS: '/admin/groups',
  ADMIN_USER_SETTINGS: '/admin/settings',
  ADMIN_LEADERS: '/admin/leaders',
  ADMIN_ENGAGEMENT: '/admin/engagement',
  FAQ_TIPS: '/admin/tips-faqs',
  PROTECTED: '/login',
  UNVERIFIED: '/email-verification',
  LIBRARY: '/library',
  DELETE_ACCOUNT: '/admin/delete-account',
  POSTS: '/posts',
  MODERATE: '/moderate',
  SHARED: '/shared',
  API: {
    DELETE_ACCOUNT: '/api/delete-user-account',
  },
};
